export default {
      id: "leads-coins-usage",
      viewBox: "0 0 15 20",
      url: __webpack_public_path__ + "img/icons.svg#leads-coins",
      toString: function () {
        return this.url;
      }
    }